document.addEventListener('DOMContentLoaded', function () {
    var buttonsOpen = document.querySelectorAll('[data-open-notification]');
    var buttonsClose = document.querySelectorAll('customer-notifications-container .halo-sidebar-header');
    var containerNotification = document.querySelector('customer-notifications-container');
    var body = document.querySelector('body');
  
    if (buttonsOpen.length && buttonsClose.length && containerNotification) {
      buttonsOpen.forEach(button => {
        button.addEventListener('click', function () {
          show();
        });
      });
  
      buttonsClose.forEach(button => {
        button.addEventListener('click', function () {
          hide();
        });
      });
  
      body.addEventListener('click', function (event) {
        if (body.classList.contains('notifications-sidebar-show')) {
          if (!event.target.closest('#halo-notification-sidebar') && !event.target.closest('[data-open-notification]')) {
            hide();
          }
        }
      });
    }
  
    function show() {
      body.classList.add('notifications-sidebar-show');
    }
  
    function hide() {
      body.classList.remove('notifications-sidebar-show');
    }
  });
